import {
    RaketaRPKListResponseT,
    RaketaRPKPayloadT,
    RaketaRPKResponseT,
    RPKCreatePayloadT,
    RPKExportExcelParamsT,
    RPKListParamsT,
    RPKListResponseT,
    RPKPayloadT,
    RPKResponseT,
    RPKTypesResponseT,
} from '@/core/types/rpk.types'
import { RPKService } from '@/core/services/rpk.service'
import { RPKI } from '@/core/interfaces/rpk.interface'

const rpkService = new RPKService()

class RpkRealisation implements RPKI {
    getRaketaRPKList(params: RPKListParamsT): Promise<RaketaRPKListResponseT> {
        return rpkService.getRaketaRPKList(params)
    }

    getRPKList(params: RPKListParamsT): Promise<RPKListResponseT> {
        return rpkService.getRPKList(params)
    }

    getRaketaRPK(id: number): Promise<RaketaRPKResponseT> {
        return rpkService.getRaketaRPK(id)
    }

    getRPK(id: number): Promise<RPKResponseT> {
        return rpkService.getRPK(id)
    }

    getTypes(): Promise<RPKTypesResponseT> {
        return rpkService.getTypes()
    }

    changeStatusRPK(rpp_id: number, status_code: string): Promise<void> {
        return rpkService.changeStatusRPK(rpp_id, status_code)
    }

    editRaketaRPK(payload: RaketaRPKPayloadT): Promise<void> {
        return rpkService.editRaketaRPK(payload)
    }

    editRPK(payload: RPKPayloadT): Promise<void> {
        return rpkService.editRPK(payload)
    }

    exportExcel(params: RPKExportExcelParamsT): Promise<any> {
        return rpkService.exportExcel(params)
    }

    exportExcelRaketa(id: number): Promise<any> {
        return rpkService.exportExcelRaketa(id)
    }

    createRaketaRPK(payload: RPKCreatePayloadT): Promise<void> {
        return rpkService.createRaketaRPK(payload)
    }

    deleteRPK(id: number): Promise<void> {
        return rpkService.deleteRPK(id)
    }
}

export const rpk = new RpkRealisation()
